export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname, asPath) {
  return path === pathname || pathname.startsWith(path);
}

export function getActiveCrew(crewId, asPath) {
  return asPath.includes(`?c=${crewId}`);
}
